/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FollowNotificationActionData } from './FollowNotificationActionData';
import {
    FollowNotificationActionDataFromJSON,
    FollowNotificationActionDataFromJSONTyped,
    FollowNotificationActionDataToJSON,
} from './FollowNotificationActionData';

/**
 * 
 * @export
 * @interface FollowNotificationAction
 */
export interface FollowNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FollowNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FollowNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FollowNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FollowNotificationActionData}
     * @memberof FollowNotificationAction
     */
    data: FollowNotificationActionData;
}

/**
 * Check if a given object implements the FollowNotificationAction interface.
 */
export function instanceOfFollowNotificationAction(value: object): value is FollowNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FollowNotificationActionFromJSON(json: any): FollowNotificationAction {
    return FollowNotificationActionFromJSONTyped(json, false);
}

export function FollowNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FollowNotificationActionDataFromJSON(json['data']),
    };
}

export function FollowNotificationActionToJSON(value?: FollowNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FollowNotificationActionDataToJSON(value.data),
    };
}

